import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import modalObserver from '@shared/utils/observers/modalObserver';

import type { ItemUserModel } from '../models/itemUser.model';

type UserSettings = {
  isOnlyCompanyContact?: boolean;
  maxSelectedUsers?: number;
};
const useAddToAssignList = (
  users?: ItemUserModel[],
  handelChangeUsers?: (users: ItemUserModel[]) => void | Promise<void>,
  userSettings?: UserSettings,
) => {
  const handleAddToAssignList = (usersItems: ItemUserModel[]) => {
    handelChangeUsers?.(usersItems);
  };

  const handleOpenInviteModal = () => {
    modalObserver.addModal(ModalNamesEnum.inviteModal, {
      props: { handleAddToAssignList, initialSelectedUsers: users, ...userSettings },
    });
  };

  return { handleOpenInviteModal };
};

export default useAddToAssignList;
